<template>
  <div>
      <el-dialog
         title="我的礼包"
         center
         :visible='mypackage_state'
         @open='getMyPackage'
         @close='closeMyPackage'
         width="500px"
         >
        <div class='tx' v-if='!getGoodsList.length'>您尚未获得任何礼包</div>
        <div class='hasgoods' v-else>
            <p class='title'>
                <span class='time'>获奖时间</span>
                <span>所获道具</span>
            </p>
            <ul class='ov_y'>
                <li v-for='(item,i) in getGoodsList' :key='i'>
                    <span class='time'>{{item.CreateTime | timeTool}}</span>
                    <span>{{item.Desc}}</span>
                </li>
            </ul>
            <div class='btn-page'>
              <el-button type="primary" size="small" @click='prevPage' :disabled="hide2">上一页</el-button>
              <el-button type="primary" size="small" @click='nextPage' :disabled="hide">下一页</el-button>
            </div>
        </div>
        <p class='botTip'>温馨提示: 虚拟道具奖品将在24小时内发到您的游戏内邮箱,请耐心等候,谢谢您的理解与支持!</p>
      </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "MyPackage",
    props: {
      mypackage_state: Boolean,
      goodsList: Object
    },
    data () {
      return {
        total: 0,
        page: 0,
        hide: false,
        hide2: true,
        token: "",
        goodsList2: [],
        getGoodsList: [],
      }
    },
    filters: {
      // 毫秒转为年月日时分秒
      timeTool (val) {
        let times = new Date(val * 1000);
        let yy = times.getFullYear(),
          mm = times.getMonth() + 1 < 10 ? "0" + (times.getMonth() + 1) : times.getMonth() + 1,
          tt = times.getDate() < 10 ? "0" + times.getDate() : times.getDate(),
          hh = times.getHours() < 10 ? "0" + times.getHours() : times.getHours(),
          min = times.getMinutes() < 10 ? "0" + times.getMinutes() : times.getMinutes(),
          ss = times.getSeconds() < 10 ? "0" + times.getSeconds() : times.getSeconds();
        return `${yy}-${mm}-${tt} ${hh}:${min}:${ss}`
      }
    },
    methods: {
      // 获取上一页
      prevPage() {
        if (this.total <= 50 && this.page > 0) {
          this.page--;
          if (this.page < 0) {
            this.hide2 = true
          }
          this.getMyPackage()
        }
      },
      // 获取下一页
      nextPage() {
        if (this.total == 50) {
          this.page++;
          this.hide2 = false
          this.getMyPackage()
        }
      },
      closeMyPackage () {
        this.page = 0;
        this.total = 0;
        this.$emit('closeMyPackage',false)
      },
      getMyPackage () {
        this.getToken() // 先获取token
        this.$http.get('mm/honor/orderlist',{
          params: {
            token: this.token,
            Page: this.page
          }
        }).then(rel => {
          if (rel.data.code == 'OK') {
            let goodsList = rel.data.data.list;
            if(goodsList.length){
              this.total = goodsList.length;
              if (this.total == 50) {
                this.hide = false;
              }else {
                this.hide = true;
              }
              this.page > 0 ? this.hide2 = false : this.hide2 = true
              this.getGoodsList = goodsList.reverse();
            }
          }
        })

      },
      // 获取token
      getToken () {
        this.token = JSON.parse(window.sessionStorage.getItem('authinfo')).token;
      },
    }
  }
</script>

<style lang='scss' scoped>
.tx {
    text-align: center;
    font-size: 18px;
    color: #666;
}
.hasgoods {
    font-size: 16px;
}
.title{ //第一种写法
    font-size: 18px;
    color:#666;
    font-weight: bold;
    margin-bottom: 15px;
}
.time {
    display: inline-block;
    width: 180px;
    margin-right: 50px;
}
.botTip {
    margin-top: 20px;
    color: #f00;
    font-size: 14px;
}
.ov_y {
    height: 313px;
    overflow-y: scroll;
}
.btn-page {
  width: 200px;
  margin: 20px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/MyPackage.vue